import React from 'react';
import { statusStyle, sourceBadge } from './financeBenchmarks';

/**
 * Small at-a-glance KPI tile for the dashboard top strip.
 *
 * Props: label, value (string), status, source, loading
 */
const KpiTile = ({
  label,
  value,
  status = 'none',
  source = 'none',
  icon,
  loading = false,
  showSourceBadge = true,
  sub,
  onClick,
  className = '',
}) => {
  const sStyle = statusStyle(status);
  const badge = sourceBadge(source);
  const interactive = typeof onClick === 'function';

  const Wrapper = interactive ? 'button' : 'div';
  const wrapperProps = interactive
    ? { type: 'button', onClick, className: `w-full text-left rounded-lg border p-3 bg-white dark:bg-gray-800 ${sStyle.border} hover:shadow-md transition-shadow cursor-pointer ${className}` }
    : { className: `rounded-lg border p-3 bg-white dark:bg-gray-800 ${sStyle.border} ${className}` };

  return (
    <Wrapper {...wrapperProps}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
          {label}
        </span>
        {icon && <span className="text-gray-400 text-xs shrink-0">{icon}</span>}
      </div>
      {loading ? (
        <div className="h-6 w-16 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
      ) : (
        <div className={`text-xl font-bold ${sStyle.text}`}>{value}</div>
      )}
      {sub && <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">{sub}</p>}
      {showSourceBadge && (
        <div className="mt-1">
          <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${badge.classes}`}>{badge.label}</span>
        </div>
      )}
    </Wrapper>
  );
};

export default KpiTile;
